import { useSelector } from 'react-redux';
import {
  ACTIVE_BASE_LAYER,
  ADD_BASE_LAYER_TO_MAP,
  REMOVE_BASE_LAYER_FROM_MAP,
} from './actionTypes';

const CheckLayer = (layer) => {
  const layers = useSelector((state) => state.layersBaseMap);
  let isLayerAdded = layers.find((activeLayer) => activeLayer === layer);
  return isLayerAdded;
};

export const addBaseLayerToMap = (map, layer) => {
  if (CheckLayer) {
    map.addLayer(layer);
  }
  return {
    type: ADD_BASE_LAYER_TO_MAP,
    payload: layer,
  };
};

export const removeBaseLayerFromMap = (map, layer) => {
  map.removeLayer(layer);
  return {
    type: REMOVE_BASE_LAYER_FROM_MAP,
    payload: layer,
  };
};

export const activeBaseLayer = (layer) => {
  return {
    type: ACTIVE_BASE_LAYER,
    payload: layer,
  };
};
